<template>
    <section class="section section-shaped section-lg my-0">
        <div class="shape shape-style-1 bg-gradient-default">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="container pt-lg-md">
            <div class="row justify-content-center">
              <!-- Content Start -->
              <div class="col-lg-8 col-md-10 mx-auto">
                <h1 class="post-heading">A new opportunity for future female VC leaders in Japan</h1>
                <span class="meta"> Posted in June 2023 </span>

                <figure>
                  <img class="img-fluid" src="img/blog/card/shizen-sprout.jpg" alt="">
                </figure>

<p>Lack of diversity in the venture capital business is a problem worldwide. As readers of my blog know from my past tirades, I believe that this pernicious issue negatively impacts VC fund returns, impedes female and other under-represented entrepreneurs, stifles the health of a region’s startup ecosystem, and deprives society as a whole of innovation.</p>
<p>One look around Japan’s VC community reveals that we’re not immune to this problem here. A few laudable exceptions of female-founded VC funds prove the rule, (AN Ventures, MPower, and NextBlue come to mind), but these rare instances can be counted on one hand.</p>
<p>My lesson from Europe, which used to rank just as poorly, was that an absence of diversity in VC stems from structural, historic, and cultural factors, and that addressing it requires efforts from all corners.</p>
<p>In our view at Shizen Capital, we have a responsibility to contribute to the solution. We also believe that perfection can sometimes be the enemy of progress. So rather than spend years theorizing on the ideal comprehensive solution, thereby allowing us to hide behind inaction, we’ve opted for action now.</p>
<h2 class="subheading">Introducing Sprout: a GP-in-training opportunity</h2>
<p>We’re thrilled to announce the Shizen Capital Sprout initiative. Sprout is a full-time opportunity for ambitious women in Japan who aspire to manage their own VC fund. Think of it as a “VC-in-residence” or “GP-in-training” program. For the Sprout participant, we will employ them in our fund, expose them to all aspects of VC fund operations, convey to the best of our abilities the decades of experience we’ve gained from investing in startups (ideally minus our bad habits), and enable them to branch out as a GP with their own fund when they decide they are ready.</p>
<p>The length of time before branching out will vary as a function of the participant’s incoming experience and personal comfort level. Becoming a full GP inside Shizen Capital could potentially even be an option as well, albeit the core vision of the program is to facilitate more female-founded funds in Japan.</p>
<p>Female candidates of all range of experiences may apply. We imagine that candidates with prior experience in investment banking, consulting, startups, or venture capital, may be particularly suitable. However, we hold no strict requirements on this. Professional ambition combined with a strong drive to support startups is the key requirement. For our first participant, we do insist on a fluent Japanese speaker (whereas English fluency is not necessary).</p>
<p>We are open to applicants now and intend to decide on the first participant after the summer. Interested candidates may contact us here: sprout@shizen.vc. Please send a short paragraph of motivation along with a CV. We promise to keep all applications confidential. (日本語でも英語でも、どちらでも結構です).</p>

              </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {};
</script>
<style>
.post-heading,
.subheading,
.section-heading,
.blockquote,
.meta,
p,
span {
  color: #fff;
}
.post-heading {
  font-size: 20px;
  font-weight: 700;
  line-height: 1;
}
.subheading {
  font-size: 20px;
  margin-top: 16px;
}
.section-heading {
  font-weight: 700;
  margin-top: 32px;
}
.section-heading + p {
  margin-top: 16px;
}
.meta + p {
  margin-top: 32px;
}
.author-info {
  font-size: 14px;
  font-style: italic;
  line-height: 1.5;
}
figure {
  margin-top: 24px;
}
</style>
